
import {
    required,
    minLength,
} from 'vuelidate/lib/validators';

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
    name: 'FeedbackFormBlock',

    data() {
        return {
            form: {
                phone: '',
            },
        };
    },

    computed: {
        errorPhone() {
            const error = this.$v?.form?.phone;
            if (!error?.$invalid || !error?.$dirty) {
                return null;
            }

            if (!error.required) {
                return 'Обязательно к заполнению';
            }
            if (!error.minLength) {
                return 'Неправильный формат ввода';
            }

            return null;
        },

        isDarkTheme() {
            return Boolean(this.cfgs?.theme === 'dark');
        },
    },

    validations() {
        const form = {
            phone: {
                required,
                minLength: minLength(18),
            },
        };

        return {
            form,
        };
    },

    methods: {
        async submitForm() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return null;
            }

            this.$store.commit('loading/setLoading', { name: 'popUpLoading', value: true });
            const body = {
                type: 'УЗНАЙ ИНДИВИДУАЛЬНУЮ ЦЕНУ',
                phone: (this.form?.phone || '').replace(/[^\d]/g, ''),
                url: window.location.href,
            };
            body.source = this.$cookies.get('sbjs_current') || '';
            const response = await this.$api.agent.transport.post('/form/send', body).then((res) => res.data).catch((err) => ({
                error: errorParseNetwork(err.response),
            }));
            if (response.error) {
                this.$store.commit('loading/setLoading', { name: 'popUpLoading', value: false });

                this.$toast.error(response.error);

                return;
            }

            this.$yandexMetrika.reachGoal('blok_octavut_saavky');
            this.$store.commit('loading/setLoading', { name: 'popUpLoading', value: false });
            this.$store.commit('pop-up-success-form/setOpen', true);
            this.resetForm();
        },
        resetForm() {
            this.form = {
                phone: '',
            };
            this.$v.$reset();
        },
    },
});
